import React from 'react';
import { arrivalLineColor } from '../../../constants/colors';
import AdmCumulativeChartWrapper from '../adm_shared/AdmCumulativeChartWrapper';

export default function AdmArrivalCumulativeChart(props) {
  const { arrival, increment, d0_interval, d2_interval } = props;

  return (
    <AdmCumulativeChartWrapper
      title='Cumulative Defect Arrival'
      arrival={arrival}
      increment={increment}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
      arrivalColor={arrivalLineColor}
      showArrival={true}
      showClosure={false}
    />
  );
}
